export const fetchDataSafely = async (apiCall, errHandler = null) => {
  try {
    const response = await apiCall()
    return response
  } catch (error) {
    errHandler && errHandler(error.response.data)
    return null
  }
}
